import { fabric } from "fabric";

export default (function() {
  function Arrow(canvas, fillColor, strokeColor, strokeWidth) {
    this.canvas = canvas;
    this.className = "Arrow";
    this.isDrawing = false;
    this.heads = this.arrowHeads;
    this.fillColor = fillColor || "#FFFFFF";
    this.strokeColor = strokeColor || "#000000";
    this.strokeWidth = strokeWidth || 2;
    this.canvas.selection = false;
    this.bindEvents();
  }

  Arrow.prototype.bindEvents = function() {
    this.canvas.on("mouse:down", (o) => {
      this.onMouseDown(o);
    });
    this.canvas.on("mouse:move", (o) => {
      this.onMouseMove(o);
    });
    this.canvas.on("mouse:up", (o) => {
      this.onMouseUp(o);
    });
    this.canvas.on("object:moving", () => {
      this.disable();
    });
  };

  Arrow.prototype.onMouseUp = function() {
    this.line.set({
      dirty: true,
      objectCaching: true
    });
    this.canvas.renderAll();
    this.disable();
  };

  Arrow.prototype.onMouseMove = function(o) {
    if (!this.isEnable()) {
      return;
    }

    var pointer = this.canvas.getPointer(o.e);
    var activeObj = this.canvas.getActiveObject();
    activeObj.set({
      x2: pointer.x,
      y2: pointer.y
    });
    activeObj.setCoords();
    this.canvas.renderAll();
  };

  Arrow.prototype.onMouseDown = function(o) {
    this.enable();
    var pointer = this.canvas.getPointer(o.e);

    var points = [pointer.x, pointer.y, pointer.x, pointer.y];
    this.line = new fabric.LineArrow(points, {
      strokeWidth: this.strokeWidth,
      fill: this.fillColor,
      stroke: this.strokeColor,
      originX: "center",
      originY: "center",
      hasBorders: true,
      hasControls: true,
      objectCaching: false,
      perPixelTargetFind: true,
      heads: this.heads
    });

    this.canvas.add(this.line).setActiveObject(this.line);
  };

  Arrow.prototype.isEnable = function() {
    return this.isDrawing;
  };

  Arrow.prototype.enable = function() {
    this.isDrawing = true;
  };

  Arrow.prototype.disable = function() {
    this.isDrawing = false;
    this.canvas.discardActiveObject().renderAll();
  };

  return Arrow;
})();